<script setup>
import { inject } from 'vue';

defineProps({
    trailingItems: {
        type: Array,
        default: () => [],
    },
});

const search = inject('app-search', null);

if (!search) {
    throw new Error('app-search-bar must be used within an app-search component');
}
</script>

<template>
    <div class="w-full max-w-[720px] h-[56px] flex gap-4 px-4 items-center rounded-full bg-white-foreground/5 mx-auto">
        <slot v-if="$slots.default" />
        <template v-else>
            <app-search-bar-icon value="search" open-view-on-click />
            <app-search-bar-placeholder />

            <slot name="trailingItems" />
            <component
                v-if="!$slots.trailingItems"
                v-for="(item, i) in trailingItems"
                :key="i"
                :is="item.type === 'avatar' ? 'app-search-bar-avatar' : 'app-search-bar-icon'"
                :value="item.value"
                @click="item.onClick"
            />
            <app-search-view />
        </template>
    </div>
</template>
